import { Component, ContentChild } from "@angular/core";

@Component({
    selector: "content-default",
    standalone: true,
    imports: [],
    templateUrl: "./content-default.component.html",
    styleUrl: "./content-default.component.scss",
})
export class ContentDefaultComponent {
    @ContentChild("header") set setHeader(header: HTMLElement) {
        this.hasHeader = !!header;
    }

    @ContentChild("footer") set setFooter(footer: HTMLElement) {
        this.hasFooter = !!footer;
    }

    hasHeader = false;
    hasFooter = false;
}
